import {
  gql 
} from "@apollo/client"

export const CheckoutPageFragment = gql`
    fragment CheckoutPageFragment on Cart {
        id
        items {
            uid
            product {
                uid
                stock_status
                estimate_delivery {
                    code
                    value
                }
                available_product{
                    sku
                    uid
                    id
                    url_key
                    name
                }
            }
        }

        shipping_addresses {
            customer_address_id
            __typename
        }
        total_quantity
        available_payment_methods {
            code
        }
    }
`
